import { Link, useLocation } from 'react-router-dom';
import { TylerNavbar } from '../nav/tylerNavbar';
import { NormalNavLink, SocialLink } from '../nav/navlink';
import { openSocialLink } from '../nav/socialLinks';
import { ThemeToggle } from './ThemeToggle';

const ACTIVE_NAME_BY_PATH: Record<string, string> = {
  '': 'Home',
  portfolio: 'My Portfolio',
  resume: 'My Resume',
  inquiries: 'Inquiries',
};

export function SiteNav() {
  const { pathname } = useLocation();
  const relative = pathname.replace(/^\/+/, '');
  const navbar = new TylerNavbar(ACTIVE_NAME_BY_PATH[relative]);

  return (
    <nav>
      <ul className="nav nav-pills justify-content-center">
        {navbar.getNavbar.map((link) => (
          <li className="nav-item" key={link.tabIndex}>
            {link instanceof NormalNavLink && (
              <span>
                <Link
                  className={navbar.getNavButtonClasses(link)}
                  to={`/${link.navLinkTarget}`}
                  tabIndex={link.tabIndex}
                  aria-current={link.isNavLinkActive ? 'page' : undefined}
                >
                  {link.navLinkName}{' '}
                  <span className="visually-hidden-focusable">{navbar.getAriaAttribute(link)}</span>
                </Link>
              </span>
            )}
            {link instanceof SocialLink && (
              <span>
                <button
                  type="button"
                  className={navbar.navButtonClasses}
                  onClick={() => openSocialLink(link.socialLinkTarget)}
                  title={link.socialLinkTitle}
                  tabIndex={link.tabIndex}
                >
                  <i className={link.socialLinkIcon} role="img" aria-hidden="true">
                    <span className="visually-hidden-focusable">{link.socialLinkTitle}</span>
                  </i>
                </button>
              </span>
            )}
            {navbar.isDarkModeToggleLink(link) && (
              <span>
                <ThemeToggle tabIndex={link.tabIndex} />
              </span>
            )}
          </li>
        ))}
      </ul>
    </nav>
  );
}
